import axiosClient from './axiosClient';
import { DashboardSummary, PipelineViewData } from '@/types/rfo';

export const dashboardApi = {
  getSummary: async (): Promise<DashboardSummary> => {
    const response = await axiosClient.get('/dashboard/summary');
    return response.data;
  },

  getPipeline: async (): Promise<PipelineViewData> => {
    const response = await axiosClient.get('/dashboard/pipeline');
    return response.data;
  },

  getMetrics: async (): Promise<Record<string, any>> => {
    const response = await axiosClient.get('/dashboard/metrics');
    return response.data;
  },

  getPostEvaluation: async (): Promise<PostEvaluationItem[]> => {
    const response = await axiosClient.get('/dashboard/post-evaluation');
    return response.data;
  },
};

export interface PostEvaluationItem {
  id: string;
  title: string;
  agencyName: string;
  status: string;
  outcome: 'WON' | 'LOST' | 'NO_DECISION' | 'PENDING';
  conductedBy: string;
  conductedAt?: string;
  updatedAt?: string;
}
